import { InjectionToken } from '@angular/core';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils';
import { DigitalDataService } from 'ib-web-commons/dist/app/core/ib-datalayer/services/ib-digital-data-service';

export const AJSAncillariesDigitalDataService = new InjectionToken<DigitalDataService>('DigitalDataService');
export const AJSDigitalDataServiceProvider = upgradeAJSServiceProvider('DigitalDataService', AJSAncillariesDigitalDataService);

export interface DigitalDataServiceType extends DigitalDataService {
}